function Measure(measure) {
  this.id = measure.id;
  this.calculationUid = measure.calculation_uid;
  this.distance = measure.distance;
  this.type = measure.type;
}

export default Measure;
